import { useState } from "react";
import "./Settings.css";

const NAV_ITEMS = [
  { id: "profile",       label: "Profile & Account",    icon: "👤" },
  { id: "notifications", label: "Notifications",         icon: "🔔" },
  { id: "display",       label: "Display & Theme",       icon: "🎨" },
  { id: "device",        label: "Baton Device",          icon: "📡" },
];

export default function Settings() {
  const [activeTab, setActiveTab] = useState("profile");
  const [saved, setSaved] = useState(false);

  const [profile, setProfile] = useState({
    name: "Ravi Kumar",
    badgeId: "AP-4821",
    rank: "Constable",
    station: "Vijayawada East PS",
    phone: "9876543210",
    email: "ravi.kumar@appolice.gov.in",
  });

  const [notifs, setNotifs] = useState({
    sosAlerts: true,
    patrolReminders: true,
    systemUpdates: false,
    incidentAlerts: true,
    soundEnabled: true,
    vibration: true,
  });

  const [display, setDisplay] = useState({
    theme: "dark",
    language: "English",
    fontSize: "Medium",
    mapDefault: "Satellite",
    showBadgeId: true,
  });


  const [device, setDevice] = useState({
    batonId: "SB-VJA-0042",
    firmware: "v2.4.1",
    battery: "87%",
    gpsAccuracy: "High",
    syncInterval: "5",
    bluetoothEnabled: true,
  });

  const handleSave = () => {
    setSaved(true);
    setTimeout(() => setSaved(false), 2800);
  };

  const Toggle = ({ checked, onChange }) => (
    <button
      type="button"
      className={`toggle ${checked ? "toggle--on" : ""}`}
      onClick={() => onChange(!checked)}
    >
      <span className="toggle-knob" />
    </button>
  );

  return (
    <div className="settings-page">
      {saved && (
        <div className="toast-success">
          <span>✅</span> Settings saved successfully!
        </div>
      )}

      <div className="settings-header">
        <div>
          <h1 className="settings-title">Settings</h1>
          <p className="settings-sub">Manage your account and device preferences</p>
        </div>
      </div>

      <div className="settings-layout">
        {/* ── Sidebar Nav ── */}
        <div className="settings-nav">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.id}
              className={`s-nav-item ${activeTab === item.id ? "s-nav-item--active" : ""}`}
              onClick={() => setActiveTab(item.id)}
            >
              <span className="nav-icon">{item.icon}</span>
              <span>{item.label}</span>
              <span className="nav-arrow">›</span>
            </button>
          ))}
        </div>

        {/* ── Content Panel ── */}
        <div className="settings-content">

          {/* ─── PROFILE ─── */}
          {activeTab === "profile" && (
            <div className="settings-section">
              <div className="section-title">Profile & Account</div>
              <div className="avatar-row">
                <div className="avatar">
                  {profile.name.split(" ").map((n) => n[0]).join("")}
                </div>
                <div>
                  <div className="avatar-name">{profile.name}</div>
                  <div className="avatar-rank">{profile.rank} · {profile.badgeId}</div>
                </div>
              </div>

              <div className="form-grid">
                <div className="field-group">
                  <label className="field-label">Full Name</label>
                  <input className="s-input" value={profile.name}
                    onChange={(e) => setProfile({ ...profile, name: e.target.value })} />
                </div>
                <div className="field-group">
                  <label className="field-label">Badge ID</label>
                  <input className="s-input" value={profile.badgeId} readOnly />
                </div>
                <div className="field-group">
                  <label className="field-label">Rank</label>
                  <select className="s-input" value={profile.rank}
                    onChange={(e) => setProfile({ ...profile, rank: e.target.value })}>
                    {["Constable", "Head Constable", "ASI", "SI", "Inspector"].map((r) => (
                      <option key={r}>{r}</option>
                    ))}
                  </select>
                </div>
                <div className="field-group">
                  <label className="field-label">Police Station</label>
                  <input className="s-input" value={profile.station}
                    onChange={(e) => setProfile({ ...profile, station: e.target.value })} />
                </div>
                <div className="field-group">
                  <label className="field-label">Phone Number</label>
                  <input className="s-input" value={profile.phone}
                    onChange={(e) => setProfile({ ...profile, phone: e.target.value })} />
                </div>
                <div className="field-group">
                  <label className="field-label">Email</label>
                  <input className="s-input" value={profile.email}
                    onChange={(e) => setProfile({ ...profile, email: e.target.value })} />
                </div>
              </div>
            </div>
          )}

          {/* ─── NOTIFICATIONS ─── */}
          {activeTab === "notifications" && (
            <div className="settings-section">
              <div className="section-title">Notifications</div>
              <div className="toggle-list">
                {[
                  { key: "sosAlerts",        label: "SOS Alerts",           desc: "Get notified instantly for SOS triggers" },
                  { key: "patrolReminders",  label: "Patrol Reminders",     desc: "Receive patrol schedule and duty alerts" },
                  { key: "incidentAlerts",   label: "Incident Alerts",      desc: "Nearby incident broadcasts from command centre" },
                  { key: "systemUpdates",    label: "System Updates",       desc: "App and firmware update notifications" },
                  { key: "soundEnabled",     label: "Alert Sound",          desc: "Play sound for incoming alerts" },
                  { key: "vibration",        label: "Vibration",            desc: "Vibrate on new alerts" },
                ].map(({ key, label, desc }) => (
                  <div key={key} className="toggle-row">
                    <div>
                      <div className="toggle-label">{label}</div>
                      <div className="toggle-desc">{desc}</div>
                    </div>
                    <Toggle
                      checked={notifs[key]}
                      onChange={(val) => setNotifs({ ...notifs, [key]: val })}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* ─── DISPLAY ─── */}
          {activeTab === "display" && (
            <div className="settings-section">
              <div className="section-title">Display & Theme</div>
              <div className="form-grid">
                <div className="field-group">
                  <label className="field-label">Theme</label>
                  <div className="theme-row">
                    {["Dark", "Light", "System"].map((t) => (
                      <button
                        key={t}
                        type="button"
                        className={`theme-btn ${display.theme === t.toLowerCase() ? "theme-btn--active" : ""}`}
                        onClick={() => setDisplay({ ...display, theme: t.toLowerCase() })}
                      >
                        {t === "Dark" ? "🌙" : t === "Light" ? "☀️" : "💻"} {t}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="field-group">
                  <label className="field-label">Language</label>
                  <select className="s-input" value={display.language}
                    onChange={(e) => setDisplay({ ...display, language: e.target.value })}>
                    {["English", "Telugu", "Hindi"].map((l) => <option key={l}>{l}</option>)}
                  </select>
                </div>
                <div className="field-group">
                  <label className="field-label">Font Size</label>
                  <select className="s-input" value={display.fontSize}
                    onChange={(e) => setDisplay({ ...display, fontSize: e.target.value })}>
                    {["Small", "Medium", "Large"].map((f) => <option key={f}>{f}</option>)}
                  </select>
                </div>
                <div className="field-group">
                  <label className="field-label">Default Map View</label>
                  <select className="s-input" value={display.mapDefault}
                    onChange={(e) => setDisplay({ ...display, mapDefault: e.target.value })}>
                    {["Satellite", "Street", "Terrain"].map((m) => <option key={m}>{m}</option>)}
                  </select>
                </div>
              </div>
              <div className="toggle-row" style={{ marginTop: "20px" }}>
                <div>
                  <div className="toggle-label">Show Badge ID on Header</div>
                  <div className="toggle-desc">Display your badge number in the top bar</div>
                </div>
                <Toggle
                  checked={display.showBadgeId}
                  onChange={(val) => setDisplay({ ...display, showBadgeId: val })}
                />
              </div>
            </div>
          )}


          {/* ─── DEVICE ─── */}
          {activeTab === "device" && (
            <div className="settings-section">
              <div className="section-title">Baton Device</div>
              <div className="device-info-grid">
                {[
                  { label: "Baton ID",     value: device.batonId },
                  { label: "Firmware",     value: device.firmware },
                  { label: "Battery",      value: device.battery },
                  { label: "GPS Accuracy", value: device.gpsAccuracy },
                ].map(({ label, value }) => (
                  <div key={label} className="device-info-item">
                    <div className="device-info-label">{label}</div>
                    <div className="device-info-value">{value}</div>
                  </div>
                ))}
              </div>

              <div className="form-grid" style={{ marginTop: "20px" }}>
                <div className="field-group">
                  <label className="field-label">Location Sync Interval (minutes)</label>
                  <select className="s-input" value={device.syncInterval}
                    onChange={(e) => setDevice({ ...device, syncInterval: e.target.value })}>
                    {["1", "2", "5", "10"].map((v) => <option key={v}>{v}</option>)}
                  </select>
                </div>
              </div>

              <div className="toggle-row" style={{ marginTop: "20px" }}>
                <div>
                  <div className="toggle-label">Bluetooth</div>
                  <div className="toggle-desc">Enable Bluetooth for baton pairing</div>
                </div>
                <Toggle
                  checked={device.bluetoothEnabled}
                  onChange={(val) => setDevice({ ...device, bluetoothEnabled: val })}
                />
              </div>

              <button className="danger-btn">🔄 Restart Baton Device</button>
            </div>
          )}

          {/* Save button */}
          <div className="save-row">
            <button className="save-btn" onClick={handleSave}>
              💾 Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
